import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import './EsgRiskContributorRows.css';
import i18n from '../../../i18n';

library.add(faQuestionCircle, faInfo);


class EsgRiskContributorRows extends Component {

    // formatPercent(number) {
    //     return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-';
    //   }

    formatValue(type, val) {
        if (typeof (val) === 'number' && type === '.') {

            return (val !== null ? `${parseFloat(val * 100).toFixed(2)}` : val);
        } else if (typeof (val) === 'number') {
            return (val !== null ? `${parseFloat(val).toFixed(2)}` : val);
        } else {
            return (val);
        }
    }
    render() {
        const {
            displayName,
            description,
            values,
            tooltips,
            bold,
            type,
            name,
        } = this.props;


        let parsedValues =
            values.map((val) => {

                let x = val + "";
                let str = x.split("--");
                if (str.length <= 1) {
                    return (str[0]);
                }
                if ((str.length > 1) && (str[2] === 'peer')) {
                    return (str[0]);
                } else {
                    const lastItem = str[1][str[1].length - 1];
                    if (lastItem === '%') {
                        return (
                            Number(str[1].substring(0, str[1].length - 1)));
                    }
                    return (str[1])
                }
            })

        let match = Math.max(...parsedValues.filter((val) => { return val !== null && val !== '-'; }));
        if (bold === 'min') {
            match = Math.min(...parsedValues.filter((val) => { return val !== null; }));
        }

        const columns = values.map((value, colIdx) => {
            if (!value) {
                return (<td key={colIdx} className='textCenter'>-</td>);
            } else {
                let valueClass = 'textCenter';
                if (Number(value) === match) {
                    valueClass = 'textCenterBold';
                }
                value = this.formatValue(type, value)
                const parts = value.split('--')
                const ticker = parts[1];
                const weight = parts[0];

                if (Number(weight) === match) {
                    valueClass = 'textCenterBold';
                }
                return (
                    <td key={`${name}-${colIdx}`} className={valueClass}>
                        {weight}
                        <div className={valueClass} >
                            {ticker}
                            {tooltips && weight !== '-' &&
                                <Fragment >
                                    <FontAwesomeIcon style={{ marginLeft: '4px', cursor: 'pointer', color: 'white', background: 'grey', borderRadius: '50%', border: '1px solid grey', fontSize: '12px', width: '.9em' }} data-tip data-for={`contrib' ${name}-${colIdx}`} icon="info" size="lg" />
                                    <ReactTooltip id={`contrib' ${name}-${colIdx}`} type='light' className="esg" effect="float">
                                        <div dangerouslySetInnerHTML={{ __html: tooltips[colIdx] }} />
                                    </ReactTooltip>
                                </Fragment>
                            }
                        </div>
                    </td>
                );
            }
        });

        return (
            <Fragment>
                <tr style={{ 'borderTop': '1px', 'borderBottom': '1px' }}>
                    <td className='textLeft'>
                        <div style={{ fontWeight: 'bold' }}>  &nbsp;&nbsp; &nbsp;&nbsp;{i18n.t(displayName)} <br />
                            <span style={{ fontStyle: 'italic', color: '#8c959b' }}> &nbsp;&nbsp; &nbsp;&nbsp; {description}</span>
                        </div>
                    </td>
                    <td colSpan={1} className='textLeft'>
                        <div>  </div>
                    </td>
                    {columns}
                </tr>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        data: state.fundData.data,
    };
}

export default connect(mapStateToProps, {
})(EsgRiskContributorRows);
